<template>
  <div>
    <WizardDetailWrapper
      :class="['tw-mb-[25px]']"
      :title="item.title"
      :data="data"
      :validation="v$.name"
      :show-accordion="item.showAccordion"
      :page-active="idPage.webFacingAppPage"
      :is-facing-web="true"
      :is-api-error="statusInPageClone"
      @update:accordion="item.showAccordion = !item.showAccordion"
      @input="updateStore(item)"
    >
      <template #title>
        <div style="position: relative; width: 100%">
          <input
            :id="`input-webfacing-${data.index}`"
            v-model="item.name"
            class="enter__name"
            :placeholder="
              getComponentUiText(
                'app-menu-submenu-home-setup-wizard-web-facing-app-placeholder-input-1',
              )
            "
            style="border: unset; background-color: unset"
            @input="
              () => {
                !item.id && (item.isCallAPI = false);
                statusInPageClone &&
                  statusInPageClone.name &&
                  delete statusInPageClone.name;
                statusInPageClone &&
                  (delete statusInPageClone.isDelete,
                  delete statusInPageClone.serviceTypeId);
                if (
                  statusInPageClone &&
                  Object.keys(statusInPageClone).length === 1 &&
                  statusInPageClone.hasOwnProperty('id')
                ) {
                  delete statusInPageClone.id;
                }
              }
            "
            @click.stop
          />
          <span
            v-if="!item.name"
            style="position: absolute; left: 275px; top: -3px; color: red"
            >*</span
          >
        </div>
      </template>
      <WizardRadioQuestion
        :class="['tw-mb-[25px]']"
        :title="
          getComponentUiText(
            'app-component-wizards-setup-wizard-more-detail-web-facing-title-1',
          )
        "
        :answer="item.isStatus"
        :required="true"
        :text-left="
          getComponentUiText('app-dashboard-current-scan-type-web-service-1')
        "
        :disabled="true"
        :not-yes-no="item.id ? true : false"
        :mesage-error="mesageError"
        :text-right="
          getComponentUiText('app-setup-webfacing-aplication-native-app-1')
        "
        @on-update="checkYesNo"
      />
      <!--
 <div v-if="mesageError" class="invalid">
        {{ getComponentUiText("app-setting-org-detail-required-fields-1") }}
      </div> 
-->
      <div class="tw-mb-[20px]">
        <WizardInputQuestion
          v-if="item.isStatus === 1"
          v-model="item.url"
          :validation="v$.url"
          :type="'text'"
          :is-api-error="statusInPageClone && item.id && statusInPageClone.url"
          :title="
            getComponentUiText(
              'app-component-wizards-setup-wizard-more-detail-web-facing-title-2',
            )
          "
          :required="true"
          :placeholder="
            getComponentUiText(
              'app-component-wizards-setup-wizard-more-detail-web-facing-title-2',
            )
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          @update:value-team-page="
            () => {
              !item.id && (item.isCallAPI = false);
              statusInPageClone &&
                statusInPageClone.url &&
                delete statusInPageClone.url;
              statusInPageClone &&
                (delete statusInPageClone.isDelete,
                delete statusInPageClone.serviceTypeId);
              if (
                statusInPageClone &&
                Object.keys(statusInPageClone).length === 1 &&
                statusInPageClone.hasOwnProperty('id')
              ) {
                delete statusInPageClone.id;
              }
              updateStore(item);
            }
          "
        />
      </div>
      <div
        v-if="item.isStatus === 0 || item.isStatus === 1"
        class="tw-flex tw-gap-[20px] tw-flex-col"
      >
        <!-- v-bind="item.isStatus === 0 ? { validation: v$.typeId } : {}" -->
        <WizardMultiLevelMultiSelectQuestion
          v-model="item.typeId"
          :title="
            item.isStatus === 1
              ? getComponentUiText('app-setting-setup-webfacing-service-type-1')
              : item.isStatus === 0
                ? getComponentUiText(
                    'app-setting-setup-webfacing-aplication-type-1',
                  )
                : ''
          "
          :placeholder="
            getComponentUiText(
              'app-wizards-setup-wizard-more-detail-select-text-1',
            )
          "
          :not-optional="
            item.isStatus === 1 ? false : item.isStatus === 0 ? true : false
          "
          :is-api-error="
            statusInPageClone && item.id && statusInPageClone.typeId
          "
          :validation="v$.typeId"
          :type="DROPDOWN_TYPE.SINGLE"
          :dropdown-data="
            item.isStatus === 1
              ? dropdownDataValue[0].childData
              : dropdownDataValue[1].childData
          "
          @update:model-value="
            () => {
              !item.id && (item.isCallAPI = false);
              statusInPageClone &&
                statusInPageClone.typeId &&
                delete statusInPageClone.typeId;
              statusInPageClone &&
                (delete statusInPageClone.isDelete,
                delete statusInPageClone.serviceTypeId);
              if (
                statusInPageClone &&
                Object.keys(statusInPageClone).length === 1 &&
                statusInPageClone.hasOwnProperty('id')
              ) {
                delete statusInPageClone.id;
              }
              updateValue(item.typeId, item);
            }
          "
        />
      </div>

      <div
        v-if="isMoreDetails"
        class="tw-flex tw-leading-[100%] tw-justify-between tw-gap-[20px] tw-bg-[#ffffff] tw-rounded-md tw-mt-5"
      >
        <div class="tw-flex tw-flex-col">
          <span
            class="tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]"
            >{{
              getComponentUiText(
                "app-component-wizards-setup-wizard-more-detail-title-1",
              )
            }}</span
          >
          <span
            class="tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-[100%] tw-font-normal tw-mr-[7px]"
            >{{
              getComponentUiText(
                "app-component-wizards-setup-wizard-more-detail-sub-title-1",
              )
            }}</span
          >
        </div>
        <div class="tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]">
          <ToggleSwitch
            :is-checked="isToggle"
            color="#2573E9"
            @update:is-checked="changeMoreDetail"
          />
        </div>
      </div>
    </WizardDetailWrapper>
  </div>
</template>

<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { ref, computed, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import { getComponentUiText, isUrlFacingWeb } from "@/utils/utilities";
import store from "@/store";
import { generateWebServiceQuestionData } from "@/services/wizard";
import {
  statusPage,
  WIZARD_STATE_NAME,
  WIZARD_STATE_QUESTION_TYPE_ID,
  idWizardPage as idPage,
  WIZARD_STATE_PAGE,
} from "@/utils/constants";
import { DROPDOWN_TYPE } from "@/utils/constants";
import WizardMultiLevelMultiSelectQuestion from "./wizardMultiLevelMultiSelectQuestion.vue";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";
const isMoreDetails = ref(false);
const isToggle = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});
const item = ref(props.data.item);
watch(
  () => props.data.item,
  (newValue) => {
    item.value = props.data.item;
  },
  { immediate: true },
);
const mesageError = ref(false);
const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find(
      (i) =>
        i.id === item.value.id &&
        (!i.serviceTypeId || i.serviceTypeId === item.value.serviceTypeId),
    )
  );
});

const statusInPageClone = ref(bodyAPIError);

const checkYesNo = (value) => {
  !item.value.id && (item.value.isCallAPI = false);
  item.value.isStatus = value;
  mesageError.value = false;
  if (!item.value.id) {
    item.value.typeId = "";
  }

  updateStore(item);
};
const updateValue = (value, data) => {
  updateStore(item);
};
const isUrlWebServiceValidation = (val) => {
  return isUrlFacingWeb(val) ? true : false;
};
const rules = computed(() => ({
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  ...(item.value.isStatus === 1 && {
    url: {
      required: helpers.withMessage(
        () => getComponentUiText("app-setting-org-detail-required-fields-1"),
        required,
      ),
      isUrlWebService: helpers.withMessage(
        () =>
          getComponentUiText("app-common-form-value-url-web-service-error-1"),
        isUrlWebServiceValidation,
      ),
    },
  }),
  ...(item.value.isStatus === 0 && {
    typeId: {
      required: helpers.withMessage(
        () => getComponentUiText("app-common-form-value-required-error-1"),
        required,
      ),
    },
  }),
}));
const webServiceData = [
  {
    questionTypeId: WIZARD_STATE_QUESTION_TYPE_ID.WEBSERVICE_WEB,
    title: "Website",
    selected: false,
    isToggle: false,
    childData: [],
  },
  {
    questionTypeId: WIZARD_STATE_QUESTION_TYPE_ID.WEBSERVICE_WEB_NAT,
    title: "Applications",
    selected: false,
    isToggle: false,
    childData: [],
  },
];

const questionSectionWebserviceValue = computed(() =>
  store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.WEBSERVICES,
    currentOrg.value.id || null,
  ),
);
let typeIdSelectedDropdown = "";

const dropdownDataValue = computed(() => {
  let result = [];
  const data = generateWebServiceQuestionData(
    webServiceData,
    questionSectionWebserviceValue.value,
  );

  result = data?.map((item) => {
    return {
      ...item,
      childData: item.childData.map((child) => ({
        ...child,
        title: child.name,
        selected: child.id === typeIdSelectedDropdown,
        questionTypeId: item.questionTypeId,
      })),
    };
  });
  return result;
});

const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  // false is errorr
  await v$.value.$validate();
  let isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (item.value.isStatus === "") {
    mesageError.value = true;
    isValid = false;
  } else if (item.value.isStatus === 1 || item.value.isStatus === 0) {
    mesageError.value = false;
  }
  if (!isValid) {
    item.value.showAccordion = true;
  }
  return { isValid };
};
defineExpose({
  saveChanges,
});
const emits = defineEmits([
  "changeDataWebFacing",
  "update:toggleValue",
  "update:value:store",
]);
const updateStore = (item) => {
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    namePage: WIZARD_STATE_PAGE.WEBSERVICES,
    currentOrg: currentOrg.value.id,
    isSelected: true,
    isSelectedPage: "isSelectedWebFacing",
  });
};

const changeMoreDetail = (value: any) => {
  emits("update:toggleValue", value);
};
</script>
<style scoped>
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  color: #211f58;
  width: 98%;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
